export * from './ngs-reveal.module';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
